
import Vue from 'vue';

export default {
	// toggle loading indicators
	setLoadingIndicator(state, { key, status })
	{
		Vue.set(state.loading, key, status);
	},

	// completely overwrite the current cart item
	setCartItem(state, item)
	{
		state.cartItem = { ...item };
	},

	// modify the cart item
	updateCartItem(state, item)
	{
		state.cartItem = { ...state.cartItem, ...item };
	},

	// select an option
	addSelectedOption(state, selection)
	{
		var { optionId, optionType } = selection;
		var current = state.optionSelections[optionType.id] || [];

		// add to list of selections if this is a multi-select option
		if (optionType.allow_multiple && current.indexOf(optionId) == -1)
		{
			Vue.set(state.optionSelections, optionType.id, [ ...current, optionId ])
		}
		// otherwise just set the array to contain the option id
		else
		{
			Vue.set(state.optionSelections, optionType.id, [optionId]);
		}
	},

	// de-select an option
	removeSelectedOption(state, selection)
	{
		var { optionId, optionType } = selection;
		var current = state.optionSelections[optionType.id];

		if (current && current.indexOf(optionId) >= 0)
		{
			var pos = current.indexOf(optionId);
			current.splice(pos, 1);
		}
	},

	// override all option selections
	setOptionSelections(state, selections)
	{
		var result = {};

		for(var id in selections)
			result[id] = selections[id].slice();

		state.optionSelections = result;
	},

	// load info about the product being ordered into the state
	setProductInfo(state, product)
	{
		state.product = { ...product };
	},

	// load product option data into the state
	setOptionList(state, list)
	{
		var options = {}, byType = {}, ids = [];

		for(var opt of list)
		{
			// add to options map, id list
			ids.push(opt.id);
			options[opt.id] = { ...opt };

			// map option by option type id
			if (!byType[opt.product_option_type_id])
				byType[opt.product_option_type_id] = [opt.id];
			else
				byType[opt.product_option_type_id].push(opt.id);
		}

		state.options = options;
		state.optionIds = ids;
		state.optionsByType = byType;
	},

	setHeadrailCount(state, num)
	{
		state.headrailNum = num;
	},

	setHeadrailControls(state, pos)
	{
		state.headrailControls = pos;
	},

	setHeadrailSize(state, params)
	{
		Vue.set(state.headrailSizes, params.index, { ...params.value });
	},

	updateSummary(state, summary)
	{
		state.summary = { ...summary };
	}
}